var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Terms and condition & Privacy links")]),
    _vm._v(" "),
    _c(
      "form",
      [
        _c("div", { staticClass: "flex justify-between w-full" }, [
          _c("div", { staticClass: "w-full spacer-r-2" }, [
            _c(
              "div",
              { class: _vm.$hasErrorClass(_vm.$v.stateTncLink, "form-group") },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Terms and conditions Link"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.stateTncLink.$model,
                      expression: "$v.stateTncLink.$model",
                      modifiers: { lazy: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "tnc_link",
                    type: "text",
                    disabled: _vm.uploading,
                  },
                  domProps: { value: _vm.$v.stateTncLink.$model },
                  on: {
                    change: function ($event) {
                      return _vm.$set(
                        _vm.$v.stateTncLink,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Terms and conditions link",
                    field: _vm.$v.stateTncLink,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-full flex flex-row items-center spacer-t-1" },
            [
              _c("div", { staticClass: "spacer-r-2" }, [
                _vm._v("\n          OR\n        "),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", { attrs: { for: "tnc_upload" } }, [
                  _vm._v("Upload Terms and Conditions"),
                ]),
                _vm._v(" "),
                _c("input", {
                  attrs: { name: "tnc_upload", id: "tnc_upload", type: "file" },
                  on: {
                    change: (output) => {
                      _vm.handleFileSelectionCallback(output, "tnc_link")
                    },
                  },
                }),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex justify-between w-full" }, [
          _c("div", { staticClass: "w-full spacer-r-2" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.statePrivacyLink,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Privacy Link"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.statePrivacyLink.$model,
                      expression: "$v.statePrivacyLink.$model",
                      modifiers: { lazy: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "privacy_link",
                    type: "text",
                    disabled: _vm.uploading,
                  },
                  domProps: { value: _vm.$v.statePrivacyLink.$model },
                  on: {
                    change: function ($event) {
                      return _vm.$set(
                        _vm.$v.statePrivacyLink,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Privacy link",
                    field: _vm.$v.statePrivacyLink,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row items-center spacer-t-1 w-full" },
            [
              _c("div", { staticClass: "spacer-r-2" }, [
                _vm._v("\n          OR\n        "),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", { attrs: { for: "privacy_link_upload" } }, [
                  _vm._v("Upload Privacy Link"),
                ]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    name: "privacy_link_upload",
                    id: "privacy_link_upload",
                    type: "file",
                  },
                  on: {
                    change: (output) => {
                      _vm.handleFileSelectionCallback(output, "privacy_link")
                    },
                  },
                }),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex justify-between w-full" }, [
          _c("div", { staticClass: "w-full spacer-r-2" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateCollectionStatementLink,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Collection statement link"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.stateCollectionStatementLink.$model,
                      expression: "$v.stateCollectionStatementLink.$model",
                      modifiers: { lazy: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "collection_statement_link",
                    type: "text",
                    disabled: _vm.uploading,
                  },
                  domProps: {
                    value: _vm.$v.stateCollectionStatementLink.$model,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(
                        _vm.$v.stateCollectionStatementLink,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Collection statement link",
                    field: _vm.$v.stateCollectionStatementLink,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row items-center spacer-t-1 w-full" },
            [
              _c("div", { staticClass: "spacer-r-2" }, [
                _vm._v("\n          OR\n        "),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", { attrs: { for: "collection_statement_upload" } }, [
                  _vm._v("Upload Collection Statement"),
                ]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    name: "collection_statement_upload",
                    id: "collection_statement_upload",
                    type: "file",
                  },
                  on: {
                    change: (output) => {
                      _vm.handleFileSelectionCallback(
                        output,
                        "collection_statement"
                      )
                    },
                  },
                }),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "ladda-button",
          {
            staticClass: "btn btn-success",
            attrs: { click: _vm.handleSaveTncSettingsCallback },
          },
          [
            _c("i", { staticClass: "fa fa-check" }),
            _vm._v(" Save Changes\n    "),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }